import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import WLogo from "../assets/TravelXOXO 1.png";
import DLogo from "../assets/TravelXOXO 2.png";

export default function TermsOfUse() {
  const [theme, setTheme] = useState("dark");

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  useEffect(() => {
    document.documentElement.classList.remove("light", "dark");
    document.documentElement.classList.add(theme);
  }, [theme]);

  return (
    <div className="bg-gray-100 text-black dark:bg-black dark:text-white min-h-screen">

      {/* HEADER */}
      <header className="bg-white dark:bg-black flex items-center justify-between px-16 py-4 border-b border-black/10 dark:border-white/10">
        <img src={WLogo} className="h-8 dark:hidden block" alt="Travelxoxo Logo" />
        <img src={DLogo} className="h-8 hidden dark:block" alt="Travelxoxo Logo" />

        <nav className="hidden md:flex gap-6 text-sm text-black/70 dark:text-white/70">
          <Link to="/" className="hover:text-black dark:hover:text-white">Home</Link>
          <Link to="/requestform" className="hover:text-black dark:hover:text-white">Request Stickers</Link>
          <Link to="/privacypolicy" className="hover:text-black dark:hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-black dark:hover:text-white">Terms of Use</Link>
        </nav>

        <button
          onClick={toggleTheme}
          className="w-12 h-12 rounded-full bg-orange-600 text-white flex items-center justify-center hover:scale-105 transition"
          title="Toggle theme"
        >
          {theme === "dark" ? "🌞" : "🌙"}
        </button>
      </header>

      {/* CONTENT */}
      <section className="max-w-5xl mx-auto px-6 md:px-16 py-16">
        <h1 className="text-3xl md:text-4xl font-extrabold mb-2">
          Terms of Use – TravelXOXO Lost and Found Tags
        </h1>

        <p className="text-sm text-black/60 dark:text-white/60 mb-10">
          Effective Date: December 15, 2025 | Last Updated: December 15, 2025
        </p>

        <div className="space-y-10 text-sm leading-relaxed text-black/80 dark:text-white/80">

          <section>
            <h2 className="text-xl font-bold mb-3">1. Acceptance of Terms</h2>
            <p>
              By scanning, registering, or using travelXOXO Lost and Found Tags
              (https://app.travelxoxo.io), you agree to these Terms of Use.
              If you do not agree, discontinue use immediately.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">2. Service Description</h2>
            <p>
              travelXOXO provides QR code–based lost and found tag services.
              Registered users create a Lost and Found page accessible via QR scan.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">3. User Registration</h2>
            <p className="mb-2">Required information includes:</p>
            <ul className="list-disc ml-6">
              <li>Full name</li>
              <li>Email address</li>
              <li>Primary and secondary phone numbers</li>
              <li>Product name</li>
              <li>Office or organization name</li>
            </ul>
            <p className="mt-2">
              Users warrant that all provided information is accurate, current, and complete.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">4. Data Collection and Use</h2>

            <h3 className="font-semibold mt-4">4.1 Information Collection</h3>
            <p>
              We collect registration data, QR scan analytics, device information,
              and usage patterns.
            </p>

            <h3 className="font-semibold mt-4">4.2 Marketing Use</h3>
            <p>
              By registering, you consent to marketing communications, promotional materials,
              product updates, and service improvements from travelXOXO and
              Hourglass Essentials Pvt Ltd.
            </p>

            <h3 className="font-semibold mt-4">4.3 Data Sharing</h3>
            <p>
              Registration information becomes publicly accessible via QR scan.
              Data may be shared with service providers, legal authorities, or
              successor entities during business transfers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">5. Intellectual Property</h2>
            <p>
              All QR codes, software, trademarks, and service content remain the
              property of Hourglass Essentials Pvt Ltd. Users receive a limited,
              non-exclusive, personal-use license only.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">6. User Responsibilities</h2>
            <p className="font-semibold">Users must:</p>
            <ul className="list-disc ml-6">
              <li>Maintain accurate information</li>
              <li>Secure QR tags and credentials</li>
              <li>Use the service lawfully</li>
              <li>Respond to legitimate recovery requests</li>
            </ul>

            <p className="font-semibold mt-4">Users must not:</p>
            <ul className="list-disc ml-6">
              <li>Provide false information</li>
              <li>Misuse found items</li>
              <li>Distribute QR codes commercially</li>
              <li>Interfere with service operations</li>
              <li>Violate applicable laws</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">7. Service Availability</h2>
            <p>
              The service is provided “as is” without uptime guarantees.
              travelXOXO may modify, suspend, or discontinue the service at any time.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">8. Limitation of Liability</h2>
            <p>
              travelXOXO and Hourglass Essentials Pvt Ltd are not liable for lost,
              stolen, or unrecovered items, misuse of information by third parties,
              service interruptions, or indirect damages.
            </p>
            <p className="mt-2">
              Maximum liability is limited to service fees paid, if applicable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">9. Privacy and Security</h2>
            <p>
              Users acknowledge that registered information becomes publicly visible
              via QR scan. Absolute security cannot be guaranteed.
              Refer to the Privacy Policy for details.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">10. Termination</h2>
            <p>
              Access may be terminated for violations, fraud, or legal requirements.
              Users may discontinue use at any time.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">11. Modifications</h2>
            <p>
              Terms may be updated at any time. Continued use constitutes acceptance
              of updated terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">12. Dispute Resolution</h2>
            <p>
              Parties agree to attempt informal resolution first. Disputes will proceed
              to binding arbitration under applicable rules.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">13. Governing Law</h2>
            <p>
              These Terms are governed by the laws of India.
              Jurisdiction lies with courts in Bangalore, Karnataka.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">14. Miscellaneous</h2>
            <ul className="list-disc ml-6">
              <li>Entire agreement</li>
              <li>Severability</li>
              <li>No waiver by non-enforcement</li>
              <li>Assignment restrictions</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">15. Contact Information</h2>
            <p className="font-medium">travelXOXO – A Product of Hourglass Essentials Pvt Ltd</p>
            <p>#39 Krishna Reddy Colony, Domlur Layout, Bangalore – 560071, India</p>
            <p>Email: itadmin@companystore.io | Phone: +91 9632950798</p>
          </section>

          <section>
            <h2 className="text-xl font-bold mb-3">16. Acknowledgment</h2>
            <p>
              By registering and using travelXOXO Lost and Found Tags, you acknowledge
              reading, understanding, and agreeing to these Terms of Use,
              including consent to marketing communications.
            </p>
          </section>

          <p className="text-xs text-black/60 dark:text-white/60">
            Document Version 1.0 | Prepared by Hourglass Essentials Pvt Ltd | Status: Active
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-white dark:bg-black border-t border-black/10 dark:border-white/10 py-8">
  <div className="max-w-5xl mx-auto px-6 md:px-16 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-black/60 dark:text-white/60">

    <div>
      © {new Date().getFullYear()} TravelXOXO. All rights reserved.
    </div>

    <div className="flex gap-6">
      <Link
        to="/privacypolicy"
        className="hover:text-black dark:hover:text-white transition"
      >
        Privacy Policy
      </Link>
      <Link
        to="/terms"
        className="hover:text-black dark:hover:text-white transition"
      >
        Terms of Use
      </Link>
    </div>

  </div>
</footer>

    </div>
  );
}
